import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dialogContentRoot: {
    maxHeight: 340,
    marginTop: 0,
  },
  linkOverload: {
    ...theme.typography.caption,
    height: 24,
    color: `${theme.palette.error.main} !important`,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  tableWrapper: {
    padding: '4px 6px',
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 4,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      WebkitBoxShadow: '0 0 1px rgba(245, 245, 245, 0.5)',
    },
  },
  form: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  table: {
    tableLayout: 'fixed',
  },
  tableCell: {
    padding: '0px 24px 0px 0px',
  },
  buttons: {
    margin: '8px 18px 18px',
  },
  backButton: {
    marginRight: '24px',
  },
  body1: theme.typography.body2,
  progress: {
    display: 'block',
    margin: '72px auto 0px',
  },
  zeroState: {
    paddingTop: '10%',
  },
  zeroSecondary: {
    textAlign: 'center',
  },
}));

